import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PropertyService } from "../../services/property";
import Loader from "components/Loader/Loader";
import { FaTrash } from "react-icons/fa";
import Modal from "components/common/Modal/Modal";
import Banner from "components/Banner/banner";
import { formatCurrency } from "ultils/currency-formatter";
import { formatDate } from "ultils/date-formatter";

const Properties: React.FC = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState<any[]>([]);
  const [ogProperties, setOGProperties] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalUnits, setTotalunits] = useState(0);
  const [selectedTile, setSelectedTile] = useState<{} | any>({});

  const [inputValue, setInputValue] = useState<string>(""); // State to track the input value
  const [isDeleteEnabled, setIsDeleteEnabled] = useState<boolean>(false); // State to enable/disable delete button

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const loadProperties = async () => {
    try {
      const data = await PropertyService.fetchProperties();
      console.log(data);
      setProperties([
        {
          streetAddress: "Add New Property",
          description: "",
          path: "/main/add-property",
        },
        ...data.property,
      ]);

      setOGProperties(data.property);

      const tot = data.property.reduce((sum: any, property: any) => {
        const units = property.numOfUnits || 1; // Treat null or 0 as 1
        return sum + units;
      }, 0);

      setTotalunits(tot);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProperties();
  }, []);

  const calculateTotalPurchaseCostOfPortfoloio = () => {
    return ogProperties.reduce((sum, property) => {
      return sum + (property.purchasePrice || 0);
    }, 0);
  };

  const tileClicked = (selectedTile: any) => {
    setSelectedTile(selectedTile);
    openModal();
  };

  const closeModalBtn = () => {
    setSelectedTile({});
    setInputValue("");
    setIsDeleteEnabled(false);
    closeModal();
  };

  // Handle the input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    // Enable the delete button if the input matches the selected street address
    if (e.target.value === selectedTile.streetAddress) {
      setIsDeleteEnabled(true);
    } else {
      setIsDeleteEnabled(false);
    }
  };

  const deleteProperty = async () => {
    try {
      await PropertyService.deleteProperty(selectedTile.propertyId);
      // Reload properties after successful deletion
      await loadProperties();
      closeModalBtn();
      alert("Property deleted successfully");
    } catch (error) {
      console.error("Error deleting property:", error);
      alert("Failed to delete property. Please try again.");
    }
  };

  return (
    <div className="bg">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1 className="dashboard-header">Properties</h1>
        <p>
          portfolio purchase cost{" "}
          <span style={{ fontSize: "2rem" }}>
            {formatCurrency(calculateTotalPurchaseCostOfPortfoloio())}
          </span>
        </p>
      </div>
      <p>
        <b>{ogProperties.length} </b> properties
        <br />
        <b>{totalUnits}</b> total units
      </p>
      {error ? <div>Error: {error}</div> : ""}
      {loading ? (
        <Loader />
      ) : (
        <div className="tiles-container">
          {properties.map((tile, index) => (
            <div key={index} className="tile">
              {tile.streetAddress === "Add New Property" ? null : (
                <div className="header-container">
                  <span
                    style={{
                      backgroundColor: tile.isMultiFamily
                        ? "#6f42c1"
                        : "#17A2B8",
                      color: "#fff",
                    }}
                    className="status-badge"
                  >
                    {tile.isMultiFamily
                      ? "Multi Family | " + tile.numOfUnits + " Units"
                      : "Single Family"}
                  </span>

                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => tileClicked(tile)}
                  >
                    <FaTrash style={{ color: "red" }} />
                  </div>
                </div>
              )}
              <h2
                style={{ textDecoration: "underline" }}
                onClick={() =>
                  tile.streetAddress === "Add New Property"
                    ? navigate("/main/add-property")
                    : navigate(`/main/property-dashboard/${tile.propertyId}`)
                }
              >
                {tile.streetAddress}
              </h2>
              <p>{tile.description}</p>
              {tile.streetAddress === "Add New Property" ? null : (
                <p>
                  aquired on:{" "}
                  <b>{formatDate(tile.purchaseDate, "MMMM, yyyy")}</b>
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      <Modal
        title={"Delete Property?"}
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <div>
          <Banner
            type="warning"
            header={"Are you sure you want to delete this property?"}
            body={
              "Deleting this property will remove it from being updated, and you will no longer see it on your dashboard. Any units attached to this property will be unaccessible. Tenants will still be accessible and editable. Financial data will also be kept to present you with financial data of your portoflio"
            }
          />

          <p>Please enter the street address to confirm deletion:</p>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Enter street address"
          />
          <p>
            <b>{selectedTile.streetAddress}</b> - this is case sensitive. Please
            write it exactly as it is displayed.
          </p>
          <div className="header-container">
            <button
              className="btn"
              onClick={closeModalBtn}
              style={{ backgroundColor: "gray", color: "white" }}
            >
              Cancel
            </button>
            <button
              className="btn"
              onClick={deleteProperty}
              disabled={!isDeleteEnabled}
              style={{ backgroundColor: "red", color: "white" }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Properties;
